import { ResponsiveService } from './shared/services/responsive.service';
import {Component, HostListener, OnInit} from '@angular/core';
import {LoadingService} from './shared/services/loading.service';
import {Carousel} from 'primeng/carousel';
import {OverlayPanel} from 'primeng/overlaypanel';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  isLoading: boolean = false;
  isMobileView: boolean = false;

  constructor(
    private loadingSrv: LoadingService,
    private responsiveSrv: ResponsiveService,
    private authService: AuthService
    ) {
    if (AppComponent.isMobile()) {
      AppComponent.turnOffCarouselChangePageOnTurn();
      AppComponent.turnOffOverlayPanelResizeListener();
    }
    this.responsiveSrv.observable.subscribe(isMobileView => this.isMobileView = isMobileView);
  }

  private static isMobile() {
    return navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/);
  }

  private static turnOffOverlayPanelResizeListener() {
    OverlayPanel.prototype.bindDocumentResizeListener = () => {
    };
  }

  private static turnOffCarouselChangePageOnTurn() {
    Carousel.prototype.changePageOnTouch = () => {
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const currentWidth = event.target.innerWidth;
    this.detectViewMode(currentWidth);
  }

  detectViewMode(width: number) {
    if (!this.isMobileView && width <= 768) {
      this.responsiveSrv.next(true);
    }
    if (this.isMobileView && width > 768) {
      this.responsiveSrv.next(false);
    }
  }

  ngOnInit() {
    this.authService.initializeFromKeycloak()
      .then(() => {
        if (!window.location.hash) {
          this.authService.isAuthenticated()
            .then(authenticated => {
              if (!authenticated) {
                this.authService.router.navigate(['/login']);
              }
            });
        }
      });
    this.loadingSrv.isLoading()
      .subscribe(x => setTimeout(() => this.isLoading = x, 100));
  }

}
